import { CALCULATE_DEBT_RESULTS } from '../../../actions/debtRepaymentCalculators/debtRepaymentCalculator';
import { debtCalculatorFormTracking } from './calculator';

export const debtCalculatorTracking = (store, next, action) => {
    if (action.type === CALCULATE_DEBT_RESULTS) {
        return debtCalculatorFormTracking(store, next, action);
    }
}
